import { Label } from "@/components/ui/label";
import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { cn } from "@/lib/utils";

interface FormFieldProps {
  label: string;
  type?: "text" | "email" | "number" | "select";
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange?: (value: string) => void;
  options?: { value: string; label: string }[];
  disabled?: boolean;
}

export const FormField = ({
  label,
  type = "text",
  placeholder,
  required,
  value,
  onChange,
  options,
  disabled,
}: FormFieldProps) => {
  return (
    <div className="space-y-2">
      <Label className="text-sm font-medium text-foreground">
        {label} {required && <span className="text-destructive">*</span>}
      </Label>
      {type === "select" && options ? (
        <Select value={value} onValueChange={onChange} disabled={disabled}>
          <SelectTrigger className={cn("w-full", disabled && "bg-muted text-muted-foreground")}>
            <SelectValue placeholder={placeholder} />
          </SelectTrigger>
          <SelectContent className="bg-card border-border z-50">
            {options.map((option) => (
              <SelectItem key={option.value} value={option.value}>
                {option.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <Input
          type={type}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          required={required}
          disabled={disabled}
          className={cn(
            "w-full",
            disabled && "bg-muted text-muted-foreground cursor-not-allowed"
          )}
        />
      )}
    </div>
  );
};
